import React, { useState, useEffect } from 'react'
import '../../assets/theme/theme.less'
import { LayoutComponent as Layout, ButtonComponent as Button } from '../../components'
import { Row, Col, Input, Select, message as alert, Form } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'
import { getProduct, createProduct, updateProduct } from '../../redux/slices/productsSlice'
import ProductFiles from './productFiles'

const { Option } = Select
const { TextArea } = Input

const ProductForm = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { id } = useParams()
    const isEdit = !!id
    const [form] = Form.useForm()
    
    const { product, isSubmit, successAction } = useSelector(state => state.products)
    const [activeTab, setActiveTab] = useState('form')

    useEffect(() => {
        if (isEdit) {
            dispatch(getProduct({ id }))
        }
    }, [dispatch, id, isEdit])

    useEffect(() => {
        if (product && isEdit) {
            form.setFieldsValue({
                nome: product.nome,
                status: product.status,
                tipo: product.tipo,
                issuer: product.issuer,
                descricao: product.descricao
            })
        }
    }, [product, isEdit, form])

    useEffect(() => {
        if (successAction) {
            if (isEdit) {
                alert.success('Produto atualizado com sucesso!')
            } else {
                alert.success('Produto criado com sucesso!')
                if (product && product.id) {
                    navigate(`/produtos/${product.id}`)
                }
            }
        }
    }, [successAction, isEdit, product, navigate])

    const handleSubmit = async (values) => {
        try {
            if (isEdit) {
                await dispatch(updateProduct({ id, ...values })).unwrap()
            } else {
                await dispatch(createProduct(values)).unwrap()
            }
        } catch (error) {
            alert.error(error || 'Erro ao salvar produto')
        }
    }

    return (
        <Layout width>
            <Row>
                <Col md={24}>
                    <h1 className="title page-title">
                        {isEdit ? 'Editar Produto' : 'Novo Produto'}
                    </h1>
                </Col>
                <Col md={24} className="mt-15">
                    <div className="d-flex">
                        <Button 
                            type={activeTab === 'form' ? 'primary' : 'default'}
                            onClick={() => setActiveTab('form')}
                            className="mr-10"
                        >
                            Dados do Produto
                        </Button>
                        {isEdit && (
                            <Button 
                                type={activeTab === 'files' ? 'primary' : 'default'}
                                onClick={() => setActiveTab('files')}
                            >
                                Arquivos
                            </Button>
                        )}
                    </div>
                </Col>
                <Col md={24} className="mt-25">
                    {activeTab === 'form' ? (
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={handleSubmit}
                            initialValues={{
                                status: 'active',
                                tipo: '',
                                issuer: ''
                            }}
                        >
                            <Row gutter={[16, 16]}>
                                <Col md={12}>
                                    <Form.Item
                                        name="nome"
                                        label={<span className="tx-pink font-bold">Nome</span>}
                                        rules={[{ required: true, message: 'Nome é obrigatório' }]}
                                    >
                                        <Input placeholder="Nome do produto" />
                                    </Form.Item>
                                </Col>
                                <Col md={12}>
                                    <Form.Item
                                        name="status"
                                        label={<span className="tx-pink font-bold">Status</span>}
                                        rules={[{ required: true, message: 'Status é obrigatório' }]}
                                    >
                                        <Select placeholder="Selecione o status">
                                            <Option value="active">Ativo</Option>
                                            <Option value="inactive">Inativo</Option>
                                            <Option value="draft">Rascunho</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col md={12}>
                                    <Form.Item
                                        name="tipo"
                                        label={<span className="tx-pink font-bold">Tipo</span>}
                                    >
                                        <Input placeholder="Tipo do produto" />
                                    </Form.Item>
                                </Col>
                                <Col md={12}>
                                    <Form.Item
                                        name="issuer"
                                        label={<span className="tx-pink font-bold">Issuer</span>}
                                    >
                                        <Input placeholder="Issuer" />
                                    </Form.Item>
                                </Col>
                                <Col md={24}>
                                    <Form.Item
                                        name="descricao"
                                        label={<span className="tx-pink font-bold">Descrição</span>}
                                    >
                                        <TextArea rows={4} placeholder="Descrição do produto" />
                                    </Form.Item>
                                </Col>
                                <Col md={24}>
                                    <Form.Item>
                                        <Button 
                                            type="primary" 
                                            htmlType="submit"
                                            loading={isSubmit}
                                        >
                                            {isEdit ? 'Atualizar' : 'Criar'} Produto
                                        </Button>
                                        <Button 
                                            type="default" 
                                            onClick={() => navigate('/produtos')}
                                            className="ml-10"
                                        >
                                            Cancelar
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    ) : (
                        <ProductFiles productId={id} />
                    )}
                </Col>
            </Row>
        </Layout>
    )
}

export default ProductForm
